import * as React from "react";
import { forwardRef } from "react";
const SvgSuccessCheckmark = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 21, viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M16.2333 5.5L7.52498 14.6667L3.56665 10.5", stroke: "#40AC0D", strokeWidth: 2.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgSuccessCheckmark);
export { ForwardRef as ReactComponent };
